<script>
export default {
    name: "Error403"
}
</script>

<template>
    <v-container fill-height fluid>
        <v-row justify="center">
            <v-col class="text-center">
                403 Нет доступа
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">

</style>